export default {
    methods: {
        createZohoLink(id){
            return 'https://crm.zoho.com/crm/org688598684/tab/Leads/' + id
        }
    }
};